const danish = () => {
    return {
        arias: {
            stepper: {
                start: "Du er på trin",
                end: "af"
            },
            back_button: "Tilbage",
            cover_selection: "Cover nummer",
            image_to_load: "Upload billede",
            image_load: "Uploader billede",
            loaded_image: "Uploadet billede",
            exampleDialogTitle: "Billedeksempel",
            next: "Næste",
            prev: "Forrige",
            fill_requironments: ""
        },
        general: {
            next: "Næste",
            pageTitle: "Bogoprettelse"
        },
        error: {
            error_upload: "Der opstod et problem med at opdatere billedet",
            many_faces: "Venligst upload et billede med ét ansigt",
        },
        click_me: "Klik på mig",
        choose: "Vælg",
        i_want_this_template: "Jeg vil have denne historie",
        shop_now: "Shop now",
        last_seen: "Sidst set"
    };
};

export default danish;
